import type { ReactNode } from 'react';
import { CurrentRouteCard } from '../CurrentRouteCard/CurrentRouteCard';
import { LiveMapActionButtons } from '../LiveMapActionButtons/LiveMapActionButtons';
import type { CurrentRouteData } from '../../../../types/CleaningControls.types';
import { MapLayer, Panel } from './LiveMapPanel.styles';
import type { LocateCommandType } from 'app/modules/machine-inventory/machine-details-panel/state/machineDetailsPanelRobot/robotCleaningControl/types/RobotCleaningControl.types';

interface LiveMapPanelProps {
  currentRoute: CurrentRouteData;
  children?: ReactNode;
  /** B50 only: the current-route overlay card. */
  showCurrentRoute?: boolean;
  isPaused?: boolean;
  isSingleRoute?: boolean;
  showSkip?: boolean;
  isSkipDisabled?: boolean;
  isSkipPending?: boolean;
  onSkipRoute?: () => void;
  /** CV50 only: Beep / Blink locate buttons. */
  showLocateActions?: boolean;
  isBeepOn?: boolean;
  isBlinkOn?: boolean;
  isLocateDisabled?: boolean;
  pendingLocateCommand?: LocateCommandType | null;
  onToggleLocateCommand?: (commandType: LocateCommandType, isOn: boolean) => void;
}

export const LiveMapPanel = ({
  currentRoute,
  children,
  showCurrentRoute = true,
  isPaused = false,
  isSingleRoute = false,
  showSkip = true,
  isSkipDisabled = false,
  isSkipPending = false,
  onSkipRoute,
  showLocateActions = false,
  isBeepOn = false,
  isBlinkOn = false,
  isLocateDisabled = false,
  pendingLocateCommand = null,
  onToggleLocateCommand,
}: LiveMapPanelProps): JSX.Element => (
  <Panel>
    <MapLayer>{children}</MapLayer>

    {showLocateActions && onToggleLocateCommand && (
      <LiveMapActionButtons
        isBeepOn={isBeepOn}
        isBlinkOn={isBlinkOn}
        isDisabled={isLocateDisabled}
        pendingCommand={pendingLocateCommand}
        onToggle={onToggleLocateCommand}
      />
    )}

    {showCurrentRoute && (
      <CurrentRouteCard
        route={currentRoute}
        isPaused={isPaused}
        isSingleRoute={isSingleRoute}
        showSkip={showSkip}
        isSkipDisabled={isSkipDisabled}
        isSkipPending={isSkipPending}
        onSkipRoute={onSkipRoute}
      />
    )}
  </Panel>
);
